<template>
  <!-- name: '优秀捐衣人 排行榜' -->
  <div class="rangkingWrap">
    <img src="https://img.bbalt.cn/imgh5/donate/bg_ranking.png" alt="" class="bgImg" />
    <div class="listBox">
      <div class="tabBox">
        <span :class="curType === 1 ? 'actClass' : ''" @click="handClick(1)"
          >季度排行榜</span
        >
        <span :class="curType === 2 ? 'actClass' : ''" @click="handClick(2)"
          >总排行榜</span
        >
      </div>
      <ul v-if="topScroller">
        <li v-for="(item, index) in curList" :key="index">
          <span
            :class="
              index > 2
                ? 'orderClass'
                : `orderClass colorClass colorClass${index}`
            "
            >{{ index + 1 }}</span
          >
          <img :src="item.imgUrl" alt="" v-default-img="defaultImgUrl" />
          <span class="nameClass">{{ item.nickName }}</span>
          <span class="gradeBox"
            >捐衣积分 <span class="gradeClass">{{ item.totalIntegral }}</span>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { integralRank } from "@/api/donate";

export default {
  components: {},
  data() {
    return {
      curList: [],
      curType: 1, //1季节，2总排名
      topScroller: false,
      defaultImgUrl: `https://img.bbalt.cn/imgh5/user_default.svg`,
    };
  },
  created() {
    this.getIntegralRank();
  },
  methods: {
    async getIntegralRank() {
      const { content } = await integralRank({ count: 20, type: this.curType });
      this.curList = content;
      this.topScroller = true;
    },
    handClick(type) {
      this.topScroller = false;
      this.curType = type;
      this.getIntegralRank();
    },
  },
};
</script>

<style lang="scss" scoped>
.rangkingWrap {
  width: 100%;
  height: calc(100% - 100px);
  overflow: hidden;
  background-image: linear-gradient(
      180deg,
      rgb(255, 255, 255) 0%,
      rgba(103, 159, 210, 0.66) 100%
    ),
    linear-gradient(180deg, rgb(172, 203, 231) 0%, rgb(103, 159, 210) 100%);
  position: relative;
  font-family: PingFangSC, PingFang SC;
  .bgImg {
    width: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
  }
  .listBox {
    width: 702px;
    height: 100%;
    background: rgba(255, 255, 255, 0.96);
    border-radius: 16px 16px 0px 0px;
    border: 2px solid #ffffff;
    left: 24px;
    top: 226px;
    position: absolute;
    .tabBox {
      margin-bottom: 49px;
      margin-top: 31px;
      display: flex;
      justify-content: space-around;

      font-size: 32px;

      font-weight: 400;
      color: #999999;
      span {
        &.actClass {
          font-size: 30px;
          color: #679fd2;
          background-image: url("https://img.bbalt.cn/imgh5/donate/img_tab.svg");
          background-repeat: no-repeat;
          background-position: center 45px;
          background-size: 37px 9px;
          height: 60px;
        }
      }
    }
    ul {
      width: 100%;
      height: 70%;
      overflow: auto;
      margin-top: 48px;
      display: flex;
      flex-flow: column;
      li {
        display: flex;
        align-items: center;
        margin-bottom: 32px;
        .orderClass {
          width: 30px;
          height: 30px;
          color: #333333;
          border-radius: 4px;
          display: inline-block;
          line-height: 30px;
          text-align: center;
          font-size: 26px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          margin-left: 32px;
          &.colorClass {
            color: #ffffff;
            font-size: 24px;
            font-weight: 600;
          }
          &.colorClass0 {
            background: #e74c4c;
          }
          &.colorClass1 {
            background: #ffb343;
          }
          &.colorClass2 {
            background: #85b2db;
          }
        }
        img {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          margin: 0px 24px;
        }
        .nameClass {
          width: 294px;
          font-size: 28px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 40px;
          text-align: left;
          margin-right: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          display: -webkit-box;
        }
        .gradeBox {
          height: 28px;
          font-size: 24px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 28px;
          .gradeClass {
            font-size: 28px;
            font-weight: 600;
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            max-width: 125px;
            display: inline-block;
          }
        }
      }
    }
  }
}
</style>
